import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import LyocTitle from '@/components/static/LyocTitle';

const Credit = () => {
	const navigate = useNavigate();

	const handleNavigateToHome = async (e: any) => {
		e.preventDefault();
		navigate('../', { replace: true });
	};

	return (
		<div>
			<LyocTitle showImg={true} />
			<h3>This game was created by</h3>
			<ul className="no-bullets">
				<li>Nicholas Comas</li>
				<li>Patch Kroll</li>
				<li>Jadon Seargant</li>
			</ul>
			<a href="https://www.kickstarter.com/projects/lyoc/last-year-of-carbon-the-board-game">
				<h3>Special Thanks to our Kickstarter Backers!</h3>
			</a>
			<h3>Special Thanks to our Playtesters</h3>
			<ul className="no-bullets">
				<li>samsterx4</li>
				<li>TheRealTomHanks</li>
				<li>bmundt6</li>
				<li>Genie993</li>
				<li>murderersrow</li>
				<li>OdieTheBee</li>
				<li>Christian314</li>
				<li>paulhpg</li>
				<li>gmaster024</li>
				<li>theGeicoGecko</li>
				<li>ColeTrain</li>
				<li>topochicosama</li>
				<li>palaghiu</li>
				<li>Not Unknown</li>
				<li>CarbonCutter</li>
				<li>ProbablyTheFirstPersonToPlayThis</li>
				<li>tyler</li>
				<li>Axonn</li>
				<li>funhouse3</li>
				<li>KaylaBean</li>
				<li>jdocturtle</li>
			</ul>
			<br />
			<div className="blk-button">
				<Button
					variant="contained"
					onClick={(e) => {
						handleNavigateToHome(e);
					}}
				>
					or Return to Login
				</Button>
			</div>
		</div>
	);
};

export default Credit;
